@import '../../helpers/helpers';

.wrap {
  width: 100%;
  text-align: right;
  margin: -40px 0 17px 0;
  padding-right: 9px;
}

.buttonWrap {
  display: inline-block;
}

.button {
  display: inline-block;
  cursor: pointer;
  position: relative;
  user-select: none;
  padding: 0 6px 0 3px;
  font-size: 17px;

  appearance: none;
  border:none;
  background: none;
}

.loading {
  pointer-events: none;
  @include loading;
}